import { api } from '@/lib/api'

export interface SavedSearchSummary {
  id: number
  name: string
  created_at: string
  updated_at: string
  vehicle_count: number
  pojistnik_name: string | null
}

export interface SavedSearch extends SavedSearchSummary {
  user_id: number
  data: Record<string, unknown>
}

export async function listSearches(): Promise<SavedSearchSummary[]> {
  const { data } = await api.get<SavedSearchSummary[]>('/searches/')
  return data
}

export async function getSearch(id: number): Promise<SavedSearch> {
  const { data } = await api.get<SavedSearch>(`/searches/${id}`)
  return data
}

export async function createSearch(name: string, payload: Record<string, unknown>): Promise<SavedSearch> {
  const { data } = await api.post<SavedSearch>('/searches/', { name, data: payload })
  return data
}

export async function updateSearch(
  id: number,
  patch: { name?: string; data?: Record<string, unknown> },
): Promise<SavedSearch> {
  const { data } = await api.put<SavedSearch>(`/searches/${id}`, patch)
  return data
}

export async function deleteSearch(id: number): Promise<void> {
  await api.delete(`/searches/${id}`)
}

export async function bulkDeleteSearches(ids: number[]): Promise<number> {
  const { data } = await api.post<{ deleted: number }>('/searches/bulk-delete', { ids })
  return data.deleted
}
